import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const SeoHelmet = ({
  title,
  description,
  keywords = [],
  links,
  meta,
  includeSEOScript,
}) => {
  const structuredJSON = JSON.stringify({
    '@content': 'http://schema.org',
    '@type': 'WebSite',
    url: 'https://tunein.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://tunein.com/search/?query={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  });
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords?.filter((kw) => kw)?.join(',')} />
      {meta?.map((attrs, index) => (
        <meta key={index} {...attrs} />
      ))}
      {links?.map((attrs, index) => (
        <link key={index} {...attrs} />
      ))}
      {includeSEOScript && (
        <script type="application/ld+json">{structuredJSON}</script>
      )}
    </Helmet>
  );
};

SeoHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  keywords: PropTypes.array.isRequired,
  links: PropTypes.array,
  meta: PropTypes.array,
  includeSEOScript: PropTypes.bool,
};

export default SeoHelmet;
